/** The line drawings of the boards, as they are drawn there (24×24, stroke `currentColor`). */
export const ICONS = {
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-4-4',
  plus: 'M12 5v14M5 12h14',
  close: 'M6 6l12 12M18 6L6 18',
  chevronDown: 'M6 9l6 6 6-6',
  chevronRight: 'M9 6l6 6-6 6',
  arrowRight: 'M5 12h14M13 6l6 6-6 6',
  arrowUp: 'M12 19V5M5 12l7-7 7 7',
  external: 'M7 17L17 7M9 7h8v8',
  dots: 'M3.2 12a1.8 1.8 0 1 0 3.6 0a1.8 1.8 0 1 0-3.6 0M10.2 12a1.8 1.8 0 1 0 3.6 0a1.8 1.8 0 1 0-3.6 0M17.2 12a1.8 1.8 0 1 0 3.6 0a1.8 1.8 0 1 0-3.6 0',
  warning: 'M12 3l10 18H2zM12 10v5M12 18v.5',
  info: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 11v6M12 7.5v.5',
  box: 'M4 7h16M6 7v13h12V7M9 4h6',
  org: 'M4 21V5h10v16M14 9h6v12M7 9h4M7 13h4M7 17h4',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18',
  flag: 'M5 21V4h11l-2 4 2 4H5',
  city: 'M4 21V8l6-4v17M10 21V10l10 3v8M4 21h16',
  group: 'M3 21V8l9-5 9 5v13M9 21v-6h6v6',
  dept: 'M4 21V7h16v14M4 11h16M9 7V4h6v3',
  store: 'M4 9l2-5h12l2 5M4 9v11h16V9M4 9h16',
  people: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21c1-4 4-6 7-6s6 2 7 6M17 3a4 4 0 0 1 0 8M22 21c-.5-2.5-2-4.5-4-5.5',
  history: 'M12 8v5l3 2M3 12a9 9 0 1 0 3-6.7M3 4v4h4',
  undo: 'M3 12a9 9 0 1 0 3-6.7M3 4v4h4',
  upload: 'M12 3v12M6 9l6-6 6 6M4 21h16',
  copy: 'M8 4h11v11M5 9h11v11H5z',
  calendar: 'M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zM3 10h18M8 3v4M16 3v4',
  shield: 'M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z',
  check: 'M5 12l5 5 9-10'
} as const;

export type IconName = keyof typeof ICONS;
